module.exports = __webpack_public_path__ + "img/event_2.1bc64789.jpg";